/**
 * The slot registrations of `web/sheets/cards` (2.M deliverable 16; CS r6c's stub taken over): the
 * header's card pill (`header.pills.card`, order 74). `apps/web/src/editor-services/slots.ts`
 * collects them as `SLOT_MODULES['web/sheets/cards']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { CardPill } from './CardPill.js';

export const owner: WorkPackageId = '2.M';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 74, owner: '2.M', component: CardPill },
];
